<template>
  <div class="steps">
    <v-step
      v-for="status in statuses"
      :key="status.text"
      :value="status.text"
      :text="status.text"
      :is-active="status.isActive"
    >
      {{ status }}
    </v-step>
  </div>
</template>

<script>
  import StepIndicatorItem from "@/atoms/StepIndicatorItem";

  export default {
    components: {
      "v-step": StepIndicatorItem,
    },
    props: {
      statuses: {
        type: Array,
        default: null
      },
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .steps {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    counter-reset: steps;
  }
</style>
